import { isJSON } from "@/components/fichaInfo/utilities/helpers";

const storeAuth = {
  tokkoBrokerHost: "",
};
async function updateToken() {
  storeAuth.tokkoBrokerHost = localStorage.getItem("tokkoBrokerHost");
  storeAuth.token = localStorage.getItem("jwt");
}

class ApiService {
  static async getRequestOptions({ method, requestData, query_params = {} }) {
    const { jwt } = query_params;
    const requestOptions = {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
    };
    if (jwt) {
      requestOptions.headers.Authorization = `Bearer ${jwt}`;
    }
    if (requestData) {
      requestOptions.body = JSON.stringify(requestData);
    }

    return requestOptions;
  }

  static async performRequestServer(url, requestOptions, baseUrl) {
    const composedURL = `${baseUrl || process.env.TOKKO_HOST}${url}`;
    const response = await fetch(composedURL, requestOptions);
    let data;

    if (process.env.NODE_ENV !== "test") {
      if (response.headers.get("Content-Type") === "application/json") {
        data = await response.json();
      } else {
        const text = await response.text();
        data = isJSON(text) ? JSON.parse(text) : {};
      }
    } else {
      data = await response.json();
    }

    if (!response.ok) {
      const error = new Error(data.message || 'Request failed');
      error.response = data;
      const errorMessage = data.message || data.error || 'Request failed';
      throw new Error(errorMessage);
    }

    return data;
  }

  static async get(url, query_params, baseUrl = storeAuth.tokkoBrokerHost) {
    const requestOptions = await this.getRequestOptions({
      method: "GET",
      query_params,
    });
    return this.performRequestServer(url, requestOptions, baseUrl);
  }

  static async post(url, requestData, jwt, TOKKO_HOST) {
    const requestOptions = await this.getRequestOptions({
      method: "POST",
      requestData,
      query_params: { jwt },
    });
    return this.performRequestServer(url, requestOptions, TOKKO_HOST)
  }

  static async delete(url, requestData, jwt, TOKKO_HOST) {
    const requestOptions = await this.getRequestOptions({
      method: "DELETE",
      requestData,
      query_params: { jwt },
    });
    return this.performRequestServer(url, requestOptions, TOKKO_HOST)
  }
}

export default ApiService;
